<!-- ============================================================ -->
<!-- SKELETON LOADER                                              -->
<!-- ============================================================ -->
@if (loading) {
  <div class="skeleton-dash">
    <div class="dash-main-content">
      <div class="dash-top">
        <div class="sk-box sk-title"></div>
      </div>
      <div class="dash-top">
        <div class="card card-padding-40">
          <div class="sk-box sk-line-lg"></div>
          <div class="sk-grid">
            @for (i of [1,2,3,4,5,6]; track i) {
              <div class="sk-box sk-cell"></div>
            }
          </div>
        </div>
      </div>
      <div class="dash-top">
        <div class="dash-top-container">
          <div class="tags-group">
            <div class="sk-box sk-badge"></div>
          </div>
          <div class="dash-action-right">
            <div class="sk-box sk-search"></div>
            <div class="sk-box sk-btn"></div>
          </div>
        </div>
      </div>
      <div class="skeleton-table">
        <div class="skeleton-table-head">
          @for (i of [1,2,3,4,5]; track i) {
            <div class="sk-box sk-th"></div>
          }
        </div>
        @for (i of [1,2,3,4,5]; track i) {
          <div class="skeleton-table-row">
            <div class="sk-box sk-td sk-td-name"></div>
            <div class="sk-box sk-td"></div>
            <div class="sk-box sk-td sk-td-sm"></div>
            <div class="sk-box sk-td sk-td-sm"></div>
            <div class="sk-box sk-td sk-td-actions"></div>
          </div>
        }
      </div>
    </div>
  </div>
}

<!-- ============================================================ -->
<!-- CONTENU RÉEL                                                 -->
<!-- ============================================================ -->
@if (!loading && group) {
  <div class="dash-main-content">
    <!-- ========== HEADER + RETOUR ========== -->
    <div class="dash-top">
      <div class="flex justify-between align-center flex-wrap gap-16">
        <div class="flex align-center gap-16">
          <button class="button button-icon neutral" (click)="goBack()" matTooltip="Retour">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <h2 class="dash-title m-0">{{ group.name }}</h2>
          <div class="tags-group">
            <div class="badge success">Niveau {{ groupLevel }}</div>
            @if (canManage) {
              <div class="badge info">Vous gérez ce groupe</div>
            }
          </div>
        </div>
        <div class="dash-action-right">
          <button class="button button-icon neutral" (click)="refreshGroup()" matTooltip="Actualiser">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <!-- ========== CARTE INFOS ========== -->
    <div class="dash-top">
      <div class="card card-padding-40">
        <div class="flex justify-between align-center flex-wrap gap-16 m-b-24">
          <h4 class="m-0">Informations du groupe</h4>
          <div class="dash-action-right flex gap-8 flex-wrap">
            @if (canManage || isSuperAdmin) {
              <button class="button button-icon primary medium"
                (click)="viewMembers()">
                <mat-icon>people</mat-icon>
                <span>Gestion des membres</span>
              </button>
            }
            @if (isSuperAdmin) {
              <button class="button button-icon primary medium"
                (click)="manageAdmins()">
                <mat-icon>admin_panel_settings</mat-icon>
                <span>Gestion des admins</span>
              </button>
            }
            @if (isSuperAdmin) {
              <button class="button button-icon neutral medium"
                (click)="editGroup()">
                <mat-icon>edit</mat-icon>
                <span>Modifier</span>
              </button>
            }
          </div>
        </div>
        <div class="info-grid">
          <div class="key-value">
            <span>Nom</span>
            <p>{{ group.name }}</p>
          </div>
          <div class="key-value">
            <span>Chemin complet</span>
            <p class="word-break">{{ group.path }}</p>
          </div>
          <div class="key-value">
            <span>Niveau</span>
            <p>Niveau {{ groupLevel }}</p>
          </div>
          <div class="key-value">
            <span>Membres directs</span>
            <p>{{ group.membersCount || 0 }}</p>
          </div>
          <div class="key-value">
            <span>Sous-groupes directs</span>
            <p>{{ group.subGroups?.length || 0 }}</p>
          </div>
          @if (isSuperAdmin) {
            <div class="key-value">
              <span>Administrateurs</span>
              <p>{{ group.admins?.length || 0 }}</p>
            </div>
          }
          @if (group.description) {
            <div class="key-value full">
              <span>Description</span>
              <p>{{ group.description }}</p>
            </div>
          }
        </div>
        <!-- Liste des admins -->
        @if (isSuperAdmin && group.admins && group.admins.length > 0) {
          <div>
            <hr class="hr hr-gray">
            <h5 class="m-t-16 m-b-16">Administrateurs de ce groupe</h5>
            <div class="flex gap-8 flex-wrap">
              @for (admin of group.admins; track admin) {
                <div class="badge warning">
                  <mat-icon style="font-size:14px;width:14px;height:14px;vertical-align:middle;">person</mat-icon>
                  {{ admin.username }}
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
    <!-- ========== BARRE SOUS-GROUPES ========== -->
    <div class="dash-top">
      <div class="dash-top-container">
        <div class="tags-group">
          <div class="badge success">{{ group.subGroups?.length || 0 }} Sous-groupe(s)</div>
          @if (groupLevel > 0) {
            <div class="badge info">Niveau {{ groupLevel }} de l'arborescence</div>
          }
        </div>
        <div class="dash-action-right">
          <div class="field-search-btn">
            <input type="text" class="search-icon"
              placeholder="Rechercher un sous-groupe"
              autocomplete="off"
              [formControl]="subGroupSearchControl">
              @if (subGroupSearchControl.value) {
                <button type="button" (click)="clearSubGroupSearch()" matTooltip="Effacer">
                  <mat-icon>close</mat-icon>
                </button>
              }
              @if (!subGroupSearchControl.value) {
                <button type="button">
                  <mat-icon>search</mat-icon>
                </button>
              }
            </div>
            @if (isSuperAdmin || canManage) {
              <button class="button button-icon primary"
                (click)="createSubGroup()">
                <mat-icon>add</mat-icon>
                <span>Créer un sous-groupe</span>
              </button>
            }
          </div>
        </div>
      </div>
      <!-- ========== TABLEAU SOUS-GROUPES ========== -->
      @if (filteredSubGroups.length > 0) {
        <table class="table">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Chemin</th>
              <th>Membres</th>
              <th>Sous-groupes</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (subGroup of paginatedSubGroups; track subGroup) {
              <tr
                [class.can-manage]="canManageGroup(subGroup.path)">
                <!-- Nom -->
                <td>
                  <div class="group-name-cell">
                    <mat-icon class="group-icon" [class.manageable]="canManageGroup(subGroup.path)">
                      {{ subGroup.subGroups && subGroup.subGroups.length > 0 ? 'folder' : 'folder_open' }}
                    </mat-icon>
                    <div class="group-name-details">
                      <div class="group-name">
                        {{ subGroup.name }}
                        @if (canManageGroup(subGroup.path)) {
                          <mat-icon
                            class="verified-icon"
                          matTooltip="Vous gérez ce groupe">verified</mat-icon>
                        }
                      </div>
                    </div>
                  </div>
                </td>
                <!-- Chemin -->
                <td>
                  <span class="group-path" [matTooltip]="subGroup.path">{{ subGroup.path }}</span>
                </td>
                <!-- Membres -->
                <td>
                  <span class="count-cell" [class.has-count]="(subGroup.membersCount || 0) > 0">
                    {{ subGroup.membersCount || 0 }}
                  </span>
                </td>
                <!-- Sous-groupes -->
                <td>
                  <span class="count-cell" [class.has-count]="(subGroup.subGroups?.length || 0) > 0">
                    {{ subGroup.subGroups?.length || 0 }}
                  </span>
                </td>
                <!-- Actions -->
                <td>
                  <ul class="table-actions-icons">
                    <li>
                      <button class="button-no-style"
                        [routerLink]="['/dashboard/groups', subGroup.id, 'view']"
                        matTooltip="Voir détails">
                        <mat-icon>visibility</mat-icon>
                      </button>
                    </li>
                    <li>
                      <button class="button-no-style"
                        (click)="viewSubGroupUsers(subGroup)"
                        matTooltip="Voir les utilisateurs">
                        <mat-icon>people</mat-icon>
                      </button>
                    </li>
                    @if (canManageGroup(subGroup.path)) {
                      <li>
                        <button class="button-no-style"
                          (click)="manageSubGroupMembers(subGroup)"
                          matTooltip="Gestion des membres">
                          <mat-icon>person_add</mat-icon>
                        </button>
                      </li>
                    }
                    <li class="dropdown-wrapper">
                      <button class="table-actions-dropdown button-no-style"
                        (click)="toggleDropdown(subGroup.id!, $event)">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <ul class="table-actions-item" [class.hide]="openDropdownId !== subGroup.id">
                        @if (isSuperAdmin) {
                          <li>
                            <button class="button-no-style text-gray hover-green fw-500"
                              (click)="manageSubGroupAdmins(subGroup); closeDropdowns()">
                              Gestion des admins
                            </button>
                          </li>
                        }
                        @if (isSuperAdmin) {
                          <li>
                            <button class="button-no-style text-gray hover-green fw-500"
                              (click)="createSubSubGroup(subGroup); closeDropdowns()">
                              Créer un sous-groupe
                            </button>
                          </li>
                        }
                        @if (isSuperAdmin) {
                          <li>
                            <button class="button-no-style text-gray hover-green fw-500"
                              (click)="editSubGroup(subGroup); closeDropdowns()">
                              Modifier
                            </button>
                          </li>
                        }
                        @if (isSuperAdmin) {
                          <li>
                            <button class="button-no-style danger fw-500"
                              (click)="deleteSubGroup(subGroup); closeDropdowns()">
                              Supprimer
                            </button>
                          </li>
                        }
                      </ul>
                    </li>
                  </ul>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
      <!-- ========== PAGINATION ========== -->
      @if (filteredSubGroups.length > 0) {
        <div class="flex justify-between align-center flex-wrap">
          <div class="select-wrapper m-t-36-i">
            <select [value]="subGroupPageSize" (change)="onSubGroupPageSizeChange($event)">
              <option [value]="5">Afficher 5 éléments</option>
              <option [value]="10">Afficher 10 éléments</option>
              <option [value]="25">Afficher 25 éléments</option>
              <option [value]="50">Afficher 50 éléments</option>
            </select>
          </div>
          @if (subGroupTotalPages > 1) {
            <div class="paginate">
              <a class="paginate-arrow left"
                [class.disabled]="subGroupPageIndex === 0"
                (click)="goToSubGroupPage(subGroupPageIndex - 1)">
                <mat-icon>chevron_left</mat-icon>
              </a>
              <ul class="paginate-item">
                @for (page of subGroupVisiblePages; track page) {
                  <li
                    [class.is-active]="page === subGroupPageIndex + 1">
                    @if (page !== -1) {
                      <a (click)="goToSubGroupPage(page - 1)">{{ page }}</a>
                    }
                    @if (page === -1) {
                      <a class="ellipsis">…</a>
                    }
                  </li>
                }
              </ul>
              <a class="paginate-arrow right"
                [class.disabled]="subGroupPageIndex >= subGroupTotalPages - 1"
                (click)="goToSubGroupPage(subGroupPageIndex + 1)">
                <mat-icon>chevron_right</mat-icon>
              </a>
            </div>
          }
        </div>
      }
      <!-- ========== ÉTAT VIDE ========== -->
      @if (filteredSubGroups.length === 0) {
        <div class="no-groups">
          <mat-icon class="no-groups-icon">folder_off</mat-icon>
          <p class="no-groups-text">
            @if (subGroupSearchControl.value) {
              Aucun sous-groupe ne correspond à votre recherche.
            }
            @if (!subGroupSearchControl.value) {
              Ce groupe ne contient aucun sous-groupe.
            }
          </p>
          @if (isSuperAdmin && !subGroupSearchControl.value) {
            <button class="button primary"
              (click)="createSubGroup()">
              <mat-icon>add</mat-icon>
              <span>Créer le premier sous-groupe</span>
            </button>
          }
        </div>
      }
    </div>
  }